import { Link } from "react-router";

import { ReferenceField } from "@/components/admin";
import { useTranslate } from "ra-core";
import { CompanyAvatar } from "../companies/CompanyAvatar";
import { RelativeDate } from "../misc/RelativeDate";
import { SaleName } from "../sales/SaleName";
import type { ActivityCompanyCreated } from "../types";
import { useActivityLogContext } from "./ActivityLogContext";

type ActivityLogCompanyCreatedProps = {
  activity: ActivityCompanyCreated;
};

export function ActivityLogCompanyCreated({
  activity,
}: ActivityLogCompanyCreatedProps) {
  const context = useActivityLogContext();
  const translate = useTranslate();
  const { company } = activity;
  return (
    <div className="p-0">
      <div className="flex flex-row space-x-1 items-center w-full">
        <CompanyAvatar width={20} height={20} record={company} />

        <div className="text-sm text-muted-foreground activity-log-container">
          <span className="activity-log-text">
            <ReferenceField
              source="sales_id"
              reference="sales"
              record={activity}
            >
              <SaleName />
            </ReferenceField>
            &nbsp;{translate("simplecrm.dashboard.activity.added_company")}&nbsp;
            <Link to={`/companies/${company.id}/show`}>{company.name}</Link>
            {context === "all" && (
              <>
                &nbsp;<RelativeDate date={activity.date} />
              </>
            )}
          </span>
        </div>
        {context === "company" && (
          <span className="text-muted-foreground text-sm">
            <RelativeDate date={activity.date} />
          </span>
        )}
      </div>
    </div>
  );
}
